import React, { useContext, useEffect } from "react";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../../types/context";
import { Service } from "../../../types/entities";
import { ServicesCarousel } from "./carousel/ServicesCarousel";

export const ChooseService = () => {
	const { services } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;
	const { reservation, onChangeTime } = useContext(
		MultistepContext
	) as MultistepContextValues;

	//When the user changes the service, we clean the reservation time
	useEffect(() => {
		onChangeTime(null);
	}, []);

	let filteredServices: Service[] = [];
	if (reservation.service && reservation.service.category.name === "Event")
		filteredServices = [
			services.find((s) => s.id === reservation.service!.id)!,
		];
	// Filter services that do not belong to the "Restaurant" category
	else
		filteredServices = services.filter(
			(service) =>
				service.category.name !== "Restaurant" &&
				service.category.name !== "Event"
		);

	return <ServicesCarousel filteredServices={filteredServices} />;
};
